import React, {useEffect, useState} from "react";
import {
    Box,
    Card,
    CardContent,
    Grid,
    Typography,
    Tabs,
    Tab,
    Button,
    Divider,
    IconButton,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    useTheme,
    useMediaQuery,
    Chip,
    Tooltip,
} from "@mui/material";
import {styled} from "@mui/system";
import {ApiDetails, KEY} from "../../../../Constants";
import FormComponent from "../Form/FormComponent";
import MessagesComponent from "../Message/MessagesComponent";
import TenantFiles from "../Download Files/TenantFiles";
import TenantReport from "../Report/TenantReport";
import TenantNotes from "../Notes/TenantNotes";
import TenantFlags from "../Flags/TenantFlags";
import TenantTemplates from "../Templates/TenantTemplates";
import TenantAgreements from "../Agreements/TenantAgreements";
import CryptoJS from "crypto-js";
import Account from "../Account/Account";
import {showSnackbar} from "../../../../components/SnackBar/SnackBar";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@material-ui/icons/Close";
import DialogContent from "@mui/material/DialogContent";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import DialogActions from "@mui/material/DialogActions";
import {TransitionProps} from "@mui/material/transitions";
import Slide from "@mui/material/Slide";
import LoadingButton from "@mui/lab/LoadingButton";
import SendIcon from "@mui/icons-material/Send";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import HomeIcon from "@mui/icons-material/Home";
import Textarea from "@mui/joy/Textarea";
import Avatar from "@mui/material/Avatar";
import {Field, Form, Formik} from "formik";
import { handle401Unauthorized, handle403Forbidden } from '../../../../utils/authErrorHandler';
import { getUserData } from '../../../../services/api/client';


const themeColor = "#2C5283";

const StyledCard = styled(Card)(({theme}) => ({
    marginBottom: theme.spacing(2),
    border: "1px solid #DDE6ED",
    borderRadius: theme.spacing(1),
    // Mobile responsive
    [theme.breakpoints.down('sm')]: {
        marginBottom: theme.spacing(1),
        borderRadius: theme.spacing(0.5),
    }
}));

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>,
    },
    ref: React.Ref<unknown>
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const StyledDialog = styled(Dialog)(({theme}) => ({
    '& .MuiDialog-paper': {
        borderRadius: '12px',
        [theme.breakpoints.down('sm')]: {
            margin: '16px',
            width: 'calc(100% - 32px)',
            maxWidth: 'none',
        }
    },
    '& .MuiDialogTitle-root': {
        padding: '16px 24px',
        borderBottom: '1px solid #e0e0e0',
        [theme.breakpoints.down('sm')]: {
            padding: '12px 16px',
        }
    },
    '& .MuiDialogContent-root': {
        padding: '24px',
        [theme.breakpoints.down('sm')]: {
            padding: '16px',
        }
    },
    '& .MuiDialogActions-root': {
        padding: '12px 24px',
        borderTop: '1px solid #e0e0e0',
        [theme.breakpoints.down('sm')]: {
            padding: '12px 16px',
            flexDirection: 'column',
            gap: '8px',
            '& .MuiButton-root': {
                width: '100%',
            }
        }
    },
}));

const DialogHeaderStyled = styled(DialogTitle)(({error, theme}) => ({
    color: error ? '#e74c3c' : '#2c3e50',
    fontWeight: 600,
    fontSize: '1.25rem',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
        fontSize: '1.1rem',
    }
}));

// Mobile-friendly button container
const ButtonContainer = styled(Box)(({theme}) => ({
    display: "flex",
    gap: theme.spacing(1),
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        gap: theme.spacing(1),
        width: '100%',
        '& .MuiButton-root': {
            width: '100%',
        }
    }
}));

// Mobile-friendly header container
const HeaderContainer = styled(Box)(({theme}) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: theme.spacing(2),
    }
}));

// Mock stringAvatar function (replace with actual implementation)
const stringAvatar = (name) => ({
    sx: {
        bgcolor: '#2C5283',
    },
    children: name ? `${name.split(' ')[0][0]}${name.split(' ')[1][0]}` : '',
});

const RightSide = ({tenantID, propertyID, tenantData, isVacated}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [accountNumber, setAccountNumber] = useState(tenantData.account_number);
    const [tenantInfo, setTenantInfo] = useState({
        id: tenantID,
        name: tenantData.first_name,
        last_name: tenantData.last_name,
        account_number: tenantData.account_number,
    });

    useEffect(() => {
        setAccountNumber(tenantData.account_number);
        setTenantInfo({
            id: tenantID,
            name: tenantData.first_name,
            last_name: tenantData.last_name,
            account_number: tenantData.account_number,
        });
    }, [tenantData, tenantID]);

    let myMapDetailsDecrypted = "";
    try {
        myMapDetailsDecrypted = CryptoJS.AES.decrypt(localStorage.getItem("myMap"), KEY);
    } catch (e) {
        console.log(e);
    }

    const originalText = myMapDetailsDecrypted.toString(CryptoJS.enc.Utf8);

    // Helper function to get auth token
    const getAuthToken = () => {
        const userData = getUserData();
        return userData ? userData.find(([key]) => key === 'access_token')?.[1] : null;
    };


    const [activeTab, setActiveTab] = useState(0);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    // Switch Unit Modal States
    const [switchUnitModal, setSwitchUnitModal] = useState(false);
    const [units, setUnits] = useState([]);
    const [selectedUnit, setSelectedUnit] = useState("");
    const [switchingUnit, setSwitchingUnit] = useState(false);
    const [loadingUnits, setLoadingUnits] = useState(false);

    const [files, setFiles] = useState({
        defaults: {
            "tenant_photo": "",
            "photo_of_national_id_front": "",
            "photo_of_national_id_back": "",
            "copy_of_contract": "",
            "inventory_checklist": ""
        }
    });

    useEffect(() => {
        fetch(
            ApiDetails + "pegasus/visionary/tenant/fetch/documents",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "token": getAuthToken() || ""
                },
                body: JSON.stringify({
                    tenant_id: tenantID,
                }),
            }
        )
            .then(async (response) => {
                let data = await response.json();
                // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
                if (response.status === 200) {
                    setFiles(data);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }, [tenantID]);

    // Switch Unit Functions
    const getUnits = (propertyID) => {
        if (!propertyID) {
            console.log("Property ID is missing");
            return;
        }

        setLoadingUnits(true);

        fetch(ApiDetails + "pegasus/visionary/property/getUnits", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "token": getAuthToken() || ""
            },
            body: JSON.stringify({property_id: propertyID}),
        })
            .then(async (response) => {
                let data = await response.json();
                // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
                if (response.status === 200) {
                    // Handle both old format (array) and new format (object with units array)
                    const unitsData = Array.isArray(data) ? data : (data.units || []);
                    setUnits(unitsData);
                } else {
                    showSnackbar({
                        title: "Error!",
                        message: "Something went wrong loading units.",
                        type: "error",
                        position: {vertical: "bottom", horizontal: "right"},
                    });
                }
                setLoadingUnits(false);
            })
            .catch((err) => {
                console.error("Fetch error:", err);
                showSnackbar({
                    title: "Error!",
                    message: "Something went wrong loading units.",
                    type: "error",
                    position: {vertical: "bottom", horizontal: "right"},
                });
                setLoadingUnits(false);
            });
    };

    const moveTenant = () => {
        if (!selectedUnit) {
            showSnackbar({
                title: "Error!",
                message: "Please select a unit to move to.",
                type: "error",
                position: {vertical: "bottom", horizontal: "right"},
            });
            return;
        }

        if (selectedUnit.unit === tenantData.house_number) {
            showSnackbar({
                title: "Error!",
                message: "Tenant is already in this unit.",
                type: "error",
                position: {vertical: "bottom", horizontal: "right"},
            });
            return;
        }

        setSwitchingUnit(true);

        fetch(ApiDetails + "pegasus/visionary/property/change/unit", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "token": getAuthToken() || ""
            },
            body: JSON.stringify({
                landlord_id: tenantData.landlord_id,
                property_id: tenantData.property_id,

                tenant_id: tenantID,
                first_name: tenantData.first_name,
                last_name: tenantData.last_name,
                phone_number: tenantData.phone_number,
                account_number: tenantData.account_number,
                previous_unit: tenantData.house_number,
                secondary_phone_number: tenantData.secondary_phone_number,

                new_unit: selectedUnit.unit, // Use selectedUnit.unit
                unit_id: selectedUnit.id // Also send unit ID if needed
            }),
        })
            .then(async (response) => {
                // Handle response...
                if (response.status === 200) {
                    showSnackbar({
                        title: "Success!",
                        message: `Tenant moved from ${tenantData.house_number} to ${selectedUnit.unit} successfully.`,
                        type: "success",
                        position: {vertical: "bottom", horizontal: "right"},
                    });
                    setSwitchUnitModal(false);
                    setSelectedUnit(null); // Reset to null
                    setTimeout(() => {
                        window.location.reload();
                    }, 1500);
                }
                setSwitchingUnit(false);
            })
            .catch((err) => {
                // Handle error...
                setSwitchingUnit(false);
            });
    };

    const handleSwitchUnitModal = () => {
        setSwitchUnitModal(true);
        getUnits(tenantData.property_id);
    };

    const sendCredentials = () => {
        let values = {
            tenant_id: tenantData.tenant_id,
            property_id: tenantData.property_id,
            phone_number: tenantData.phone_number,
            secondary_phone_number: tenantData.secondary_phone_number,
            first_name: tenantData.first_name,
            account_number: tenantData.account_number,
            landlord_id: JSON.parse(originalText)[0][1],
        };

        fetch(ApiDetails + "pegasus/visionary/tenant/credentials", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "token": getAuthToken() || ""
            },
            body: JSON.stringify(values),
        })
            .then(async (response) => {
                // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
                if (response.status === 200) {
                    showSnackbar({
                        title: "Success!",
                        message: "Credentials sent successfully.",
                        type: "success",
                        position: {vertical: "bottom", horizontal: "right"},
                    });
                } else if (response.status === 500) {
                    showSnackbar({
                        title: "Error!",
                        message: "Could not send credentials.",
                        type: "error",
                        position: {vertical: "bottom", horizontal: "right"},
                    });
                }
            })
            .catch((err) => {
                console.log(err);
                showSnackbar({
                    title: "Error!",
                    message: "Something went wrong. Kindly try again later.",
                    type: "error",
                    position: {vertical: "bottom", horizontal: "right"},
                });
            });
    };

    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState({
        amount: "",
        description: "",
    });

    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData({...formData, [name]: value});
    };

    const addArrears = () => {
        if (!formData.amount || !formData.description) {
            showSnackbar({
                title: "Error!",
                message: "Amount and description are required.",
                type: "error",
                position: {vertical: "bottom", horizontal: "right"},
            });
            return;
        }

        let body = {
            tenant_id: tenantID,
            description: formData.description,
            amount: parseInt(formData.amount),
        };

        fetch(ApiDetails + "pegasus/visionary/tenant/add/arrears", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "token": getAuthToken() || ""
            },
            body: JSON.stringify(body),
        })
            .then(async (response) => {
                // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
                if (response.status === 200) {
                    showSnackbar({
                        title: "Success!",
                        message: "Arrear added successfully.",
                        type: "success",
                        position: {vertical: "bottom", horizontal: "right"},
                    });
                    setOpen(false);
                    setFormData({amount: "", description: ""});
                } else {
                    showSnackbar({
                        title: "Error!",
                        message: "Something went wrong. Kindly try again later.",
                        type: "error",
                        position: {vertical: "bottom", horizontal: "right"},
                    });
                }
            })
            .catch((err) => {
                showSnackbar({
                    title: "Error!",
                    message: "Something went wrong. Kindly try again later.",
                    type: "error",
                    position: {vertical: "bottom", horizontal: "right"},
                });
            });
    };

    const [transactionModal, setTransactionModal] = useState(false);
    const [dateFrom, setDateFrom] = useState(new Date());
    const [addingTransaction, setAddingTransaction] = useState(false);

    const addTransaction = (values) => {
        if (!values.amount) {
            showSnackbar({
                title: "Error!",
                message: "Transaction amount cannot be empty.",
                type: "error",
                position: {vertical: "bottom", horizontal: "right"},
            });
            return;
        }

        if (!dateFrom) {
            showSnackbar({
                title: "Error!",
                message: "Transaction date cannot be empty.",
                type: "error",
                position: {vertical: "bottom", horizontal: "right"},
            });
            return;
        }

        setAddingTransaction(true);

        let body = {
            TransactionType: "Pay Bill",
            TransID: "**********",
            TransTime: dateFrom.toISOString(),
            TransAmount: parseFloat(values.amount),
            BusinessShortCode: "",
            BillRefNumber: accountNumber,
            InvoiceNumber: "",
            OrgAccountBalance: "00.00",
            ThirdPartyTransID: "",
            MSISDN: "",
            FirstName: "",
            tenant_id: tenantID,
            landlord_id: JSON.parse(originalText)[0][1],
        };

        fetch(ApiDetails + "pegasus/visionary/payments/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "token": getAuthToken() || ""
            },
            body: JSON.stringify(body),
        })
            .then(async (response) => {
                // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
                if (response.status === 200) {
                    showSnackbar({
                        title: "Success!",
                        message: "Transaction added successfully.",
                        type: "success",
                        position: {vertical: "bottom", horizontal: "right"},
                    });
                } else {
                    showSnackbar({
                        title: "Error!",
                        message: "Transaction not added.",
                        type: "error",
                        position: {vertical: "bottom", horizontal: "right"},
                    });
                }
                setAddingTransaction(false);
                setTransactionModal(false);
                setDateFrom(new Date());
                window.location.reload();
            })
            .catch((err) => {
                console.log(err);
                showSnackbar({
                    title: "Error!",
                    message: "Failed updating tenant payment.",
                    type: "error",
                    position: {vertical: "bottom", horizontal: "right"},
                });
                setAddingTransaction(false);
                setTransactionModal(false);
                window.location.reload();
            });
    };

    const [messageModal, setMessageModal] = useState(false);
    const [broadcastMessage, setBroadcastMessage] = useState("");
    const [messageLoading, setMessageLoading] = useState(false);

    const sendMessage = () => {
        if (!broadcastMessage) {
            showSnackbar({
                title: "Error!",
                message: "Cannot send an empty message.",
                type: "error",
                position: {vertical: "bottom", horizontal: "right"},
            });
            return;
        }

        setMessageLoading(true);

        let values = {
            message: broadcastMessage,
            tenant_id: tenantData.tenant_id,
            first_name: tenantData.first_name,
            phone_number: tenantData.phone_number,
            property_id: tenantData.property_id,
            secondary_phone_number: tenantData.secondary_phone_number,
            landlord_id: JSON.parse(originalText)[0][1],
        };

        fetch(ApiDetails + "pegasus/visionary/tenant/message", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "token": getAuthToken() || ""
            },
            body: JSON.stringify(values),
        })
            .then(async (response) => {
                // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
                if (response.status === 200) {
                    showSnackbar({
                        title: "Success!",
                        message: "Message sent successfully.",
                        type: "success",
                        position: {vertical: "bottom", horizontal: "right"},
                    });
                    setMessageModal(false);
                    setBroadcastMessage("");
                } else {
                    showSnackbar({
                        title: "Error!",
                        message: "Something went wrong. Call customer care for assistance.",
                        type: "error",
                        position: {vertical: "bottom", horizontal: "right"},
                    });
                }
                setMessageLoading(false);
            })
            .catch((err) => {
                console.log(err);
                showSnackbar({
                    title: "Error!",
                    message: "Something went wrong. Call customer care for assistance.",
                    type: "error",
                    position: {vertical: "bottom", horizontal: "right"},
                });
                setMessageLoading(false);
            });
    };

    const handleClose = () => {
        setOpen(false);
        setMessageModal(false);
        setTransactionModal(false);
        setSwitchUnitModal(false);
        setFormData({amount: "", description: ""});
        setBroadcastMessage("");
        setDateFrom(new Date());
        setSelectedUnit("");
        setUnits([]);
    };

    const initialValues = {
        amount: "",
    };

    return (
        <>
            {/* Switch Unit Modal */}
            <StyledDialog
                open={switchUnitModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                maxWidth="sm"
                fullWidth
            >
                <DialogHeaderStyled>
                    Switch Unit for {tenantData.first_name} {tenantData.last_name}
                </DialogHeaderStyled>
                <DialogContent>
                    <Box sx={{textAlign: "center", mb: 3}}>
                        <Avatar
                            {...stringAvatar(`${tenantInfo.name} ${tenantInfo.last_name}`)}
                            sx={{width: 64, height: 64, margin: "0 auto 16px", fontSize: 24}}
                        />
                        <Typography variant="h6" sx={{mb: 1}}>
                            {tenantInfo.name} {tenantInfo.last_name}
                        </Typography>
                        <Chip
                            label={`Current Unit: ${tenantData.house_number}`}
                            color="primary"
                            icon={<HomeIcon/>}
                            sx={{mb: 2}}
                        />
                    </Box>

                    <Box sx={{display: "flex", flexDirection: "column", gap: "20px"}}>
                        <FormControl fullWidth>
                            <InputLabel sx={{color: "#5A5A5A", fontSize: "0.9rem"}}>
                                Select New Unit
                            </InputLabel>
                            <Select
                                value={selectedUnit?.id || ""}
                                label="Select New Unit"
                                onChange={(e) => {
                                    const selectedUnitId = e.target.value;
                                    const unitObject = units.find(unit => unit.id === selectedUnitId);
                                    setSelectedUnit(unitObject);
                                }}
                                disabled={loadingUnits}
                                sx={{
                                    backgroundColor: "#FFF",
                                    borderRadius: "8px",
                                    boxShadow: "inset 0px 1px 6px rgba(0, 0, 0, 0.1)",
                                }}
                            >
                                {loadingUnits ? (
                                    <MenuItem disabled>Loading units...</MenuItem>
                                ) : units.length === 0 ? (
                                    <MenuItem disabled>No available units</MenuItem>
                                ) : (
                                    units
                                        .filter(unit => unit.unit !== tenantData.house_number)
                                        .map((unit) => (
                                            <MenuItem
                                                key={unit.id}
                                                value={unit.id}
                                                disabled={unit.state === 'OCCUPIED'}
                                                sx={{
                                                    opacity: unit.state === 'OCCUPIED' ? 0.5 : 1,
                                                    '&.Mui-disabled': {
                                                        opacity: 0.5,
                                                        color: 'rgba(0, 0, 0, 0.38)'
                                                    }
                                                }}
                                            >
                                                <Box sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    width: '100%',
                                                    gap: 1
                                                }}>
                                                    <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                                        <HomeIcon fontSize="small"/>
                                                        {unit.unit}
                                                    </Box>

                                                    {unit.state === 'OCCUPIED' ? (
                                                        <Chip
                                                            label="Occupied"
                                                            size="small"
                                                            color="error"
                                                            variant="outlined"
                                                            sx={{
                                                                fontSize: '0.75rem',
                                                                height: '20px'
                                                            }}
                                                        />
                                                    ) : (
                                                        <Chip
                                                            label="Vacant"
                                                            size="small"
                                                            color="success"
                                                            variant="outlined"
                                                            sx={{
                                                                fontSize: '0.75rem',
                                                                height: '20px'
                                                            }}
                                                        />
                                                    )}
                                                </Box>
                                            </MenuItem>
                                        ))
                                )}
                            </Select>
                        </FormControl>

                        {selectedUnit && (
                            <Box sx={{
                                p: 2,
                                backgroundColor: "#f5f5f5",
                                borderRadius: "8px",
                                textAlign: "center"
                            }}>
                                <Typography variant="body2" color="textSecondary">
                                    Moving from:
                                </Typography>
                                <Typography variant="h6" color="primary" sx={{mb: 1}}>
                                    Unit {tenantData.house_number} → Unit {selectedUnit.unit}
                                </Typography>
                                <Typography variant="caption" color="textSecondary">
                                    Selected Unit ID: {selectedUnit.id}
                                </Typography>
                            </Box>
                        )}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleClose}
                        variant="outlined"
                        color="inherit"
                        sx={{
                            mr: isMobile ? 0 : 2,
                            borderRadius: "10px",
                            textTransform: "none",
                            minHeight: isMobile ? 44 : 'auto'
                        }}
                    >
                        Cancel
                    </Button>
                    <LoadingButton
                        variant="contained"
                        color="primary"
                        onClick={moveTenant}
                        loading={switchingUnit}
                        disabled={!selectedUnit || loadingUnits}
                        startIcon={<SwapHorizIcon/>}
                        loadingPosition="start"
                        sx={{
                            borderRadius: "10px",
                            textTransform: "none",
                            background: "linear-gradient(90deg, #2C5283, #25446E)",
                            "&:hover": {background: "#1E3A66"},
                            minHeight: isMobile ? 44 : 'auto'
                        }}
                    >
                        Switch Unit
                    </LoadingButton>
                </DialogActions>
            </StyledDialog>

            {/* Add Arrears Modal */}
            <StyledDialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                maxWidth="sm"
                fullWidth
            >
                <DialogHeaderStyled>Add Arrears</DialogHeaderStyled>
                <DialogContent>
                    <Box sx={{display: "flex", flexDirection: "column", gap: "20px"}}>
                        <TextField
                            label="Amount"
                            name="amount"
                            type="number"
                            variant="outlined"
                            fullWidth
                            value={formData.amount}
                            onChange={handleChange}
                            InputLabelProps={{
                                sx: {color: "#5A5A5A", fontSize: "0.9rem"},
                            }}
                            InputProps={{
                                style: {
                                    backgroundColor: "#FFF",
                                    borderRadius: "8px",
                                    boxShadow: "inset 0px 1px 6px rgba(0, 0, 0, 0.1)",
                                },
                            }}
                        />
                        <TextField
                            label="Description"
                            name="description"
                            type="text"
                            variant="outlined"
                            fullWidth
                            multiline
                            rows={3}
                            value={formData.description}
                            onChange={handleChange}
                            InputLabelProps={{
                                sx: {color: "#5A5A5A", fontSize: "0.9rem"},
                            }}
                            InputProps={{
                                style: {
                                    backgroundColor: "#FFF",
                                    borderRadius: "8px",
                                    boxShadow: "inset 0px 1px 6px rgba(0, 0, 0, 0.1)",
                                },
                            }}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleClose}
                        variant="outlined"
                        color="inherit"
                        sx={{
                            mr: isMobile ? 0 : 2,
                            borderRadius: "10px",
                            textTransform: "none",
                            minHeight: isMobile ? 44 : 'auto'
                        }}
                    >
                        Cancel
                    </Button>
                    <LoadingButton
                        variant="contained"
                        color="primary"
                        onClick={addArrears}
                        loading={false}
                        startIcon={<SendIcon/>}
                        loadingPosition="start"
                        sx={{
                            borderRadius: "10px",
                            textTransform: "none",
                            background: "linear-gradient(90deg, #2C5283, #25446E)",
                            "&:hover": {background: "#1E3A66"},
                            minHeight: isMobile ? 44 : 'auto'
                        }}
                    >
                        Submit
                    </LoadingButton>
                </DialogActions>
            </StyledDialog>

            {/* Message Modal */}
            <StyledDialog
                open={messageModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                maxWidth="sm"
                fullWidth
            >
                <DialogHeaderStyled>Message to {tenantData.first_name}</DialogHeaderStyled>
                <DialogContent>
                    <Textarea
                        minRows={5}
                        placeholder="Type message .."
                        onChange={(event) => setBroadcastMessage(event.target.value)}
                        value={broadcastMessage}
                        sx={{width: "100%", borderRadius: "8px"}}
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleClose}
                        variant="outlined"
                        color="inherit"
                        sx={{
                            mr: isMobile ? 0 : 2,
                            borderRadius: "10px",
                            textTransform: "none",
                            minHeight: isMobile ? 44 : 'auto'
                        }}
                    >
                        Cancel
                    </Button>
                    <LoadingButton
                        variant="contained"
                        color="primary"
                        onClick={sendMessage}
                        loading={messageLoading}
                        startIcon={<SendIcon/>}
                        loadingPosition="start"
                        sx={{
                            borderRadius: "10px",
                            textTransform: "none",
                            background: "linear-gradient(90deg, #2C5283, #25446E)",
                            "&:hover": {background: "#1E3A66"},
                            minHeight: isMobile ? 44 : 'auto'
                        }}
                    >
                        Send
                    </LoadingButton>
                </DialogActions>
            </StyledDialog>

            {/* Transaction Modal */}
            <StyledDialog
                open={transactionModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                maxWidth="sm"
                fullWidth
            >
                <DialogHeaderStyled>Record Payment</DialogHeaderStyled>
                <DialogContent>
                    <Box sx={{textAlign: "center", mb: 3}}>
                        <Avatar
                            {...stringAvatar(`${tenantInfo.name} ${tenantInfo.last_name}`)}
                            sx={{width: 64, height: 64, margin: "0 auto 16px", fontSize: 24}}
                        />
                        <Typography variant="h6">
                            {tenantInfo.name} {tenantInfo.last_name}
                        </Typography>
                    </Box>
                    <Formik initialValues={initialValues} onSubmit={addTransaction}>
                        {() => (
                            <Form noValidate>
                                <Box sx={{mb: 3}}>
                                    <Field
                                        as={TextField}
                                        name="amount"
                                        label="Amount"
                                        type="number"
                                        fullWidth
                                        required
                                        variant="outlined"
                                        helperText="Enter the payment amount"
                                        InputLabelProps={{
                                            sx: {color: "#5A5A5A", fontSize: "0.9rem"},
                                        }}
                                        InputProps={{
                                            style: {
                                                backgroundColor: "#FFF",
                                                borderRadius: "8px",
                                                boxShadow: "inset 0px 1px 6px rgba(0, 0, 0, 0.1)",
                                            },
                                        }}
                                    />
                                </Box>
                                <Box sx={{mb: 3}}>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            disableFuture
                                            label="Payment Date"
                                            openTo="day"
                                            views={["year", "month", "day"]}
                                            value={dateFrom}
                                            onChange={(newValue) => setDateFrom(newValue)}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    fullWidth
                                                    InputLabelProps={{
                                                        sx: {color: "#5A5A5A", fontSize: "0.9rem"},
                                                    }}
                                                    sx={{
                                                        backgroundColor: "#FFF",
                                                        borderRadius: "8px",
                                                        boxShadow: "inset 0px 1px 6px rgba(0, 0, 0, 0.1)",
                                                    }}
                                                />
                                            )}
                                        />
                                    </LocalizationProvider>
                                </Box>
                                <Box sx={{display: "flex", justifyContent: "flex-end", gap: 1}}>
                                    <Button
                                        onClick={handleClose}
                                        variant="outlined"
                                        color="inherit"
                                        sx={{
                                            mr: isMobile ? 0 : 2,
                                            borderRadius: "10px",
                                            textTransform: "none",
                                            minHeight: isMobile ? 44 : 'auto'
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                    <LoadingButton
                                        variant="contained"
                                        color="primary"
                                        type="submit"
                                        loading={addingTransaction}
                                        startIcon={<SendIcon/>}
                                        loadingPosition="start"
                                        sx={{
                                            borderRadius: "10px",
                                            textTransform: "none",
                                            background: "linear-gradient(90deg, #2C5283, #25446E)",
                                            "&:hover": {background: "#1E3A66"},
                                            minHeight: isMobile ? 44 : 'auto'
                                        }}
                                    >
                                        Record Payment
                                    </LoadingButton>
                                </Box>
                            </Form>
                        )}
                    </Formik>
                </DialogContent>
            </StyledDialog>

            <Box sx={{ width: '100%' }}>
                {/* Mobile-friendly Tabs Section */}
                <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    textColor="primary"
                    indicatorColor="primary"
                    variant={isMobile ? "scrollable" : "standard"}
                    scrollButtons={isMobile ? "auto" : false}
                    allowScrollButtonsMobile
                    sx={{
                        marginBottom: 2,
                        '& .MuiTab-root': {
                            minWidth: isMobile ? 120 : 'auto',
                            fontSize: isMobile ? '0.875rem' : '1rem',
                            padding: isMobile ? '6px 8px' : '6px 12px',
                        }
                    }}
                >
                    <Tab label="Account"/>
                    <Tab label={isMobile ? "Edit" : "Edit Details"}/>
                    <Tab label="Messages"/>
                    <Tab label="Files"/>
                    <Tab label="Report"/>
                    <Tab label="Notes"/>
                    {/*<Tab label="Templates"/>*/}
                    <Tab label="Agreements"/>
                    <Tab label="Flags"/>
                </Tabs>

                {/* Tab Content */}
                {activeTab === 0 && (
                    <StyledCard>
                        <CardContent sx={{
                            padding: isMobile ? 2 : 3,
                            '&:last-child': {
                                paddingBottom: isMobile ? 2 : 3
                            }
                        }}>
                            <HeaderContainer>
                                <Typography
                                    variant="h6"
                                    fontWeight="bold"
                                    color={themeColor}
                                    gutterBottom={isMobile}
                                >
                                    Account
                                </Typography>

                                <ButtonContainer>
                                    {/* COMMENTED OUT - Switch Unit Button */}
                                    {/* <Tooltip title={isVacated ? "Cannot switch unit for a vacated tenant" : ""} arrow>
                                        <span>
                                            <Button
                                                variant="outlined"
                                                sx={{
                                                    textTransform: "none",
                                                    backgroundColor: "#FBF4F0",
                                                    minHeight: isMobile ? 44 : 'auto'
                                                }}
                                                onClick={handleSwitchUnitModal}
                                                disabled={isVacated}
                                            >
                                                Switch Unit
                                            </Button>
                                        </span>
                                    </Tooltip> */}
                                    <Tooltip title={isVacated ? "Cannot record payment for a vacated tenant" : ""} arrow>
                                        <span>
                                            <Button
                                                variant="outlined"
                                                sx={{
                                                    textTransform: "none",
                                                    backgroundColor: "#FBF4F0",
                                                    minHeight: isMobile ? 44 : 'auto'
                                                }}
                                                onClick={() => setTransactionModal(true)}
                                                disabled={isVacated}
                                            >
                                                Make Payment
                                            </Button>
                                        </span>
                                    </Tooltip>
                                    <Tooltip title={isVacated ? "Cannot add arrears for a vacated tenant" : ""} arrow>
                                        <span>
                                            <Button
                                                variant="outlined"
                                                sx={{
                                                    textTransform: "none",
                                                    backgroundColor: "#FBF4F0",
                                                    minHeight: isMobile ? 44 : 'auto'
                                                }}
                                                onClick={() => setOpen(true)}
                                                disabled={isVacated}
                                            >
                                                Add Arrear
                                            </Button>
                                        </span>
                                    </Tooltip>
                                </ButtonContainer>
                            </HeaderContainer>

                            <Divider sx={{marginY: isMobile ? "8px" : "10px", backgroundColor: "#2C5283"}}/>

                            <Account
                                                tenantID={tenantID}
                                                propertyID={tenantData.property_id}
                                                tenantData={tenantData}
                                                landlordId={JSON.parse(originalText)[0][1]}
                                                onLeaseUpdated={() => window.location.reload()}
                                            />
                        </CardContent>
                    </StyledCard>
                )}

                {activeTab === 1 && (
                    <StyledCard>
                        <CardContent sx={{
                            padding: isMobile ? 2 : 3,
                            '&:last-child': {
                                paddingBottom: isMobile ? 2 : 3
                            }
                        }}>
                            <Typography
                                variant="h6"
                                fontWeight="bold"
                                color={themeColor}
                                gutterBottom
                            >
                                Update Tenant Information
                            </Typography>

                            <Divider sx={{marginY: isMobile ? "8px" : "10px", backgroundColor: "#2C5283"}}/>

                            {isVacated ? (
                                <Box sx={{
                                    p: 3,
                                    textAlign: 'center',
                                    bgcolor: '#fff8e1',
                                    borderRadius: 2,
                                    border: '1px solid #ffa726'
                                }}>
                                    <Typography variant="body1" color="warning.main" fontWeight={500}>
                                        Cannot edit information for a vacated tenant
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" sx={{mt: 1}}>
                                        This tenant has vacated and their information is now read-only
                                    </Typography>
                                </Box>
                            ) : (
                                <FormComponent tenatDetails={tenantData} originalDetails={originalText}/>
                            )}
                        </CardContent>
                    </StyledCard>
                )}

                {activeTab === 2 && (
                    <StyledCard>
                        <CardContent sx={{
                            padding: isMobile ? 2 : 3,
                            '&:last-child': {
                                paddingBottom: isMobile ? 2 : 3
                            }
                        }}>
                            <HeaderContainer>
                                <Typography
                                    variant="h6"
                                    fontWeight="bold"
                                    color={themeColor}
                                    gutterBottom={isMobile}
                                >
                                    Tenant Messages
                                </Typography>

                                <ButtonContainer>
                                    <Tooltip title={isVacated ? "Cannot send SMS to a vacated tenant" : ""} arrow>
                                        <span>
                                            <Button
                                                variant="outlined"
                                                sx={{
                                                    textTransform: "none",
                                                    backgroundColor: "#FBF4F0",
                                                    minHeight: isMobile ? 44 : 'auto'
                                                }}
                                                onClick={() => setMessageModal(true)}
                                                disabled={isVacated}
                                            >
                                                Send SMS
                                            </Button>
                                        </span>
                                    </Tooltip>
                                    <Tooltip title={isVacated ? "Cannot send credentials to a vacated tenant" : ""} arrow>
                                        <span>
                                            <Button
                                                variant="outlined"
                                                sx={{
                                                    textTransform: "none",
                                                    backgroundColor: "#FBF4F0",
                                                    minHeight: isMobile ? 44 : 'auto'
                                                }}
                                                onClick={sendCredentials}
                                                disabled={isVacated}
                                            >
                                                Resend Credentials
                                            </Button>
                                        </span>
                                    </Tooltip>
                                </ButtonContainer>
                            </HeaderContainer>

                            <Divider sx={{marginY: isMobile ? "8px" : "10px", backgroundColor: "#2C5283"}}/>

                            <MessagesComponent
                                tenatDetails={tenantData}
                                landlordID={JSON.parse(originalText)[0][1]}
                            />
                        </CardContent>
                    </StyledCard>
                )}

                {activeTab === 3 && (
                    <StyledCard>
                        <CardContent sx={{
                            padding: isMobile ? 2 : 3,
                            '&:last-child': {
                                paddingBottom: isMobile ? 2 : 3
                            }
                        }}>
                            <Typography
                                variant="h6"
                                fontWeight="bold"
                                color={themeColor}
                                gutterBottom
                            >
                                Download Files
                            </Typography>

                            <Divider sx={{marginY: isMobile ? "8px" : "10px", backgroundColor: "#2C5283"}}/>

                            <TenantFiles
                                files={files}
                                tenantDetails={tenantData}
                                originalText={originalText}
                                propertyID={tenantData.property_id}
                                propertyName={tenantData.property_name}
                                isVacated={isVacated}
                            />
                        </CardContent>
                    </StyledCard>
                )}

                {activeTab === 4 && (
                    <StyledCard>
                        <CardContent sx={{
                            padding: isMobile ? 2 : 3,
                            '&:last-child': {
                                paddingBottom: isMobile ? 2 : 3
                            }
                        }}>
                            <Typography
                                variant="h6"
                                fontWeight="bold"
                                color={themeColor}
                                gutterBottom
                            >
                                Tenant Report Generator
                            </Typography>

                            <Divider sx={{marginY: isMobile ? "8px" : "10px", backgroundColor: "#2C5283"}}/>

                            <TenantReport tenantDetails={tenantData}/>
                        </CardContent>
                    </StyledCard>
                )}

                {activeTab === 5 && (
                    <StyledCard>
                        <CardContent sx={{
                            padding: isMobile ? 2 : 3,
                            '&:last-child': {
                                paddingBottom: isMobile ? 2 : 3
                            }
                        }}>
                            <Typography
                                variant="h6"
                                fontWeight="bold"
                                color={themeColor}
                                gutterBottom
                            >
                                Tenant Notes
                            </Typography>

                            <Divider sx={{marginY: isMobile ? "8px" : "10px", backgroundColor: "#2C5283"}}/>

                            <TenantNotes
                                tenantID={tenantID}
                                landlordID={JSON.parse(originalText)[0][1]}
                                token={getAuthToken() || ""}
                                isVacated={isVacated}
                            />
                        </CardContent>
                    </StyledCard>
                )}

               {/* {activeTab === 6 && (
                    <StyledCard>
                        <CardContent sx={{
                            padding: isMobile ? 2 : 3,
                            '&:last-child': {
                                paddingBottom: isMobile ? 2 : 3
                            }
                        }}>
                            <Typography
                                variant="h6"
                                fontWeight="bold"
                                color={themeColor}
                                gutterBottom
                            >
                                Document Templates
                            </Typography>

                            <Divider sx={{marginY: isMobile ? "8px" : "10px", backgroundColor: "#2C5283"}}/>

                            <TenantTemplates
                                tenantDetails={tenantData}
                                landlordID={JSON.parse(originalText)[0][1]}
                                token={JSON.parse(originalText)[15][0] !== 'access_token' ? JSON.parse(originalText)[28][1] : JSON.parse(originalText)[15][1]}
                                isVacated={isVacated}
                            />
                        </CardContent>
                    </StyledCard>
                )}*/}

                {activeTab === 6 && (
                    <StyledCard>
                        <CardContent sx={{
                            padding: isMobile ? 2 : 3,
                            '&:last-child': {
                                paddingBottom: isMobile ? 2 : 3
                            }
                        }}>
                            <Typography
                                variant="h6"
                                fontWeight="bold"
                                color={themeColor}
                                gutterBottom
                            >
                                Tenancy Agreements
                            </Typography>

                            <Divider sx={{marginY: isMobile ? "8px" : "10px", backgroundColor: "#2C5283"}}/>

                            <TenantAgreements
                                tenantDetails={tenantData}
                                landlordID={JSON.parse(originalText)[0][1]}
                                propertyID={tenantData.property_id}
                                token={JSON.parse(originalText)[15][0] !== 'access_token' ? JSON.parse(originalText)[28][1] : JSON.parse(originalText)[15][1]}
                                isVacated={isVacated}
                            />
                        </CardContent>
                    </StyledCard>
                )}

                {activeTab === 7 && (
                    <StyledCard>
                        <CardContent sx={{
                            padding: isMobile ? 2 : 3,
                            '&:last-child': {
                                paddingBottom: isMobile ? 2 : 3
                            }
                        }}>
                            <Typography
                                variant="h6"
                                fontWeight="bold"
                                color={themeColor}
                                gutterBottom
                            >
                                Tenant Flags
                            </Typography>

                            <Divider sx={{marginY: isMobile ? "8px" : "10px", backgroundColor: "#2C5283"}}/>

                            <TenantFlags
                                tenantID={tenantID}
                                landlordID={JSON.parse(originalText)[0][1]}
                                propertyID={propertyID || tenantData.property_id}
                                token={getAuthToken() || ""}
                                isVacated={isVacated}
                            />
                        </CardContent>
                    </StyledCard>
                )}
            </Box>
        </>
    );
};

export default RightSide;